import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import { getTypedSelectComponents } from 'components/Select';
import { generalTypes } from 'utils/asset/commonCustomTypes';
import { getContentItemIconFromType } from 'utils/icons';
import { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
var _getTypedSelectCompon = getTypedSelectComponents(),
  Select = _getTypedSelectCompon.Select,
  Option = _getTypedSelectCompon.Option;
var AssetTypeField = function AssetTypeField(_ref) {
  var originalType = _ref.originalType,
    type = _ref.type,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = 'selectAssetType';
  var originalTypeTitle = "".concat(t(getContentItemTypeTranslationKey(originalType)), " (").concat(t('file_type_default'), ")");

  // If the asset's original type is also a custom type, remove duplicate item from the list
  var customTypeList = generalTypes.filter(function (item) {
    return item.value !== originalType;
  });
  return /*#__PURE__*/React.createElement(FormField, {
    label: t('form_displayed_type'),
    labelId: id,
    horizontal: true
  }, /*#__PURE__*/React.createElement(Select, {
    icon: getContentItemIconFromType(type),
    labelledById: id,
    size: "medium",
    menuPlacement: "top",
    value: type,
    onChange: onChange,
    variant: "transparent",
    ml: "-xxs",
    isDisabled: isDisabled
  }, /*#__PURE__*/React.createElement(Option, {
    key: originalType,
    value: originalType,
    icon: getContentItemIconFromType(originalType)
  }, originalTypeTitle), customTypeList.map(function (type) {
    return /*#__PURE__*/React.createElement(Option, {
      key: type.value,
      value: type.value,
      icon: type.icon
    }, t(getContentItemTypeTranslationKey(type.value)));
  })));
};
export default AssetTypeField;